<script>
import BaseLineItem from './../../TableList/LineItem.vue'
export default {
  extends: BaseLineItem,
  methods: {
    handleLineItemClick() {
      let lineItem = Object.assign({}, this.lineItem, {
        product_index: this.index
      })
      this.$emitter.emit('Modal', {
        name: 'order.create-sub-order.edit-line-item',
        data: lineItem,
        $el: null
      })
    }
  }
}
</script>
